"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_STRATEGY_ATTRIBUTES = void 0;
const gql_1 = require("../../../__generated__/gql");
exports.GET_STRATEGY_ATTRIBUTES = (0, gql_1.gql)(`
  query StrategyAttributes(
    $productTreeNodeId: ID!,
    $sort: [ProductTreeNodeUniqueLabelOrderBy!],
    $filter: ProductTreeNodeUniqueLabelListFilter,
    $first: Int,
    $after: ID,
    $last: Int,
    $before: ID,
  ) {
    productTreeNode(id: $productTreeNodeId) {
      id
      labelValidation(filter: $filter, sort: $sort, first: $first, after: $after, last: $last, before: $before) {
        edges {
          node {
            label
            description
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
        }
      }
    }
  }
`);
